import { Alert, Collapse } from '@mui/material';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { ChatErrorStateAtom } from '../hooks/chatActionHooks';

export const AutoClearErrorTimeoutMs = 10_000;

// treat chat errors as informational, one error does not necessarily mean the whole chat functionality is broken
export function ChatErrorAlert() {
  const [error, setAtomError] = useAtom(ChatErrorStateAtom);

  useEffect(() => {
    if (error == null) {
      return;
    }
    const timer = setTimeout(() => setAtomError(null), AutoClearErrorTimeoutMs);
    return () => clearTimeout(timer);
  }, [error, setAtomError]);

  const handleClose = () => {
    setAtomError(null);
  };

  return (
    <Collapse in={error != null}>
      {error ? (
        <Alert severity='error' onClose={handleClose}>
          {error}
        </Alert>
      ) : (
        <div style={{ height: '1px' }} /> // layout placeholder;
      )}
    </Collapse>
  );
}
